import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { auto: Boolean };

  connect() {
    if (this.autoValue) {
      this.trigger();
    }
  }

  trigger() {
    window.print();
  }
}
